import script from "./RoomView.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomView.vue?vue&type=script&setup=true&lang=js"

import "./RoomView.vue?vue&type=style&index=0&id=244a3e06&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-244a3e06"]])

export default __exports__